import { VideoUrl } from './VideoUrl';

const videoUrlPlugins = document.querySelectorAll('.tx-avmplugins-video-external');

videoUrlPlugins.forEach((element) => {

    const hasPrivacyOverlay = element.querySelector('.privacy-overlay') !== null;
    if (hasPrivacyOverlay) {
        element.addEventListener('privacyoverlay:close', () => {
            new VideoUrl(element);
        });
    } else {
        new VideoUrl(element);
    }

});
